export const MARGIN_DECIMALS = 0;
